export default __webpack_public_path__ + "static/media/IMG_7574.7e937cd5.jpeg";